// @flow
import { actions as ssoActions } from 'state/reducers/serverReducer';
import { actions as authActions } from 'state/reducers/authReducer';
import { getIdentitySession } from 'state/selectors';
import {
  addNotification,
  ERROR_LEVEL,
} from 'portfolio-shared/state/commands/globalNotificationsCommands';
import localizedStrings from 'util/localizedStrings';
import { actions as modalPromptActions } from 'portfolio-shared/state/reducers/modalPromptReducer';
import type { Dispatch, GetState } from 'state/types';
import { encrypt } from 'util/serverUtils';

const {
  setSingleSignOnCredentials: setSingleSignOnCredentialsAction,
} = ssoActions;
const { showModalPrompt } = modalPromptActions;

const { getPublicKeyInfo } = authActions;

export function setSingleSignOnCredentials(
  username: string,
  unencryptedPassword: string
) {
  return async function setSingleSignOnCredentials(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const identitySession = getIdentitySession(getState());
    const publicKeyInfoResult = await dispatch(getPublicKeyInfo());
    let encryptedPassword;
    encryptedPassword = encrypt(
      unencryptedPassword,
      publicKeyInfoResult.payload
    );
    if (identitySession) {
      let error;
      await dispatch(
        setSingleSignOnCredentialsAction(
          identitySession,
          username,
          encryptedPassword
        )
      ).catch(e => {
        error = e;
      });
      if (error) {
        dispatch(
          addNotification(
            localizedStrings.NOTIFICATION_FAILURE_UPDATE,
            ERROR_LEVEL
          )
        );
      } else {
        dispatch(
          showModalPrompt({
            dataTestName: 'sso-config-success',
            message: localizedStrings.SERVER_RESTART_REQUIRED,
          })
        );
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/ssoCommands.js